jQuery(document).ready(function($) {

  /* LOAD MORE LISTENER */
  var page = 1; // What page we are on.
  var post_per_page = 9; // Post per page
  var search = ''; // Post per page
  var sheet = 0;

  //Click to load more listener
  $('.js-loadmore-articles').click(function (e) { 
    get_articles();
  });

  //Search articles listener
	$('.js-articles-filter').submit(function (e) { 
    e.preventDefault();
    page = 0;
    $('.js-list-articles').empty();
    search = $('.js-articles-search').val();
    $('.fullwsearching__reset').addClass('fullwsearching__reset--active');
    get_articles();
  });

  //set sheet listener
  $('.js-articles-sheets span').click(function (e) { 
    sheet = $(this).attr('id');
    page = 0;
    $('.js-list-articles').empty();
    $('.js-articles-sheets span').removeClass('active');
    $(this).addClass('active');
    get_articles();
  });
  
    //reset filter
  $('.js-articles-filter .fullwsearching__reset').click(function (e) { 
    e.preventDefault();
    $('.js-articles-search').removeClass('active').val('');
    $('.js-list-articles').empty();
    page = 0;
    search = '';
    get_articles();
    $('.fullwsearching__reset').removeClass('fullwsearching__reset--active');
  });
  



  /* LOAD ARTICLES */
  function get_articles() {
    params = {};
		params.search = search;
    params.sheet = sheet;
    params.offset = (page * post_per_page);
    params.post_per_page = post_per_page;
    
    $('.fullwsearching__submit').addClass('button-loading').attr('disabled','disabled');
		var ajaxUrl =  '/wp-admin/admin-ajax.php';
		$.post(ajaxUrl, {
        action:'filterArticles_ajax',
        data: params,
        dataType: 'json',
		contentType : 'application/json;charset=utf-8',
    }).done(function(result_json){
        page++;
        if(result_json.length) {
          result = jQuery.parseJSON(result_json);
          $('.js-list-articles').append(result.articles);
          //load more button hide/show
          if (result.hide_button) {
            $('.js-loadmore-articles').hide();
          } else {
            $('.js-loadmore-articles').show();
          }
        }
        $('.fullwsearching__submit').removeClass('button-loading').removeAttr('disabled');
    });
    
  }

});